import { createContext, useContext } from 'react';
import type { ObjectRecord } from '@/services/db/object/entity';
import type { ObjectType } from '@/services/db/object-type/entity';
import type { ObjectDetailTab, ObjectDetailTabId } from './tabs';

export type { ObjectDetailTab, ObjectDetailTabId };

export type ObjectDetailContextValue = {
  record: ObjectRecord;
  objectType: ObjectType;
  workspaceId: number;
  canConfigureObjects: boolean;
  canCreateRelationships: boolean;
  canDelete: boolean;
  canExport: boolean;
  isMultiIdentifier: boolean;
  shouldRedactCreatedAt: boolean;
  /** Which tab the current URL sits on, so the tab bar can mark it. */
  activeTab: ObjectDetailTabId;
  /** Opens the add-relationships modal and refreshes the relationship reads on confirm. */
  onAddRelationships: () => void;
  hrefs: {
    overview: string;
    /**
     * Tab URLs. Attributes and relationships are Hydra's own; activity is still
     * served by the embedded app until FPS-2795 migrates it.
     */
    tabs: Record<ObjectDetailTab, string>;
    attributesEdit: string;
    typeList: string;
  };
};

const ObjectDetailContext = createContext<ObjectDetailContextValue | null>(null);

export const ObjectDetailProvider = ObjectDetailContext.Provider;

export function useObjectDetail(): ObjectDetailContextValue {
  const value = useContext(ObjectDetailContext);
  if (value == null) {
    throw new Error('useObjectDetail must be used within the object detail route');
  }
  return value;
}
